import Vue from 'vue';
import Fragment from 'vue-fragment';
import VeeValidate from 'vee-validate'; // validation plugin
import * as VueGoogleMaps from 'vue2-google-maps';
import { TooltipPlugin, AlertPlugin, CollapsePlugin, ModalPlugin } from 'bootstrap-vue';  // ui plugins
import store from './store';
import App from './containers/event-category-landing-filter-app.vue';
import * as CONST from './utils/constants';

Vue.use(Fragment.Plugin);

// init ui plugins add/remove as needed
Vue.use(AlertPlugin);
Vue.use(TooltipPlugin);
Vue.use(CollapsePlugin);
Vue.use(ModalPlugin);

Vue.use(VueGoogleMaps, {
	load: {
		key: CONST.googleMapsKey,
		libraries: 'places', // This is required if you use the Autocomplete plugin
	},
});

// init validation plugin
Vue.use(VeeValidate, {
	events: 'change|blur',
	//inject: false,
});

const dictionary = {
	custom: {
		zipcode: {
			max: () => 'Please enter a valid zip code',
			min: () => 'Please enter a valid zip code'
		},
	}
};

// Override and merge the dictionaries
VeeValidate.Validator.localize('en', dictionary);

// init app
new Vue({
	store,
	components: {
		app: App
	},
}).$mount('#ecl-app');